import { AuthRoles } from "../../../configs/roles";
import { CustomerUIProvider } from "./CustomerUIContext";

//MENU
import { CustomerUICard } from "./CustomerUICard";
import { CreateCustomer } from "./pages/CreateCustomer";
import { CustomerConfirmDoneDialog } from "./pages/CustomerConfirmDoneDialog";
import { CustomerDetail } from "./pages/CustomerDetail";
import { DeleteCustomer } from "./pages/DeleteCustomer";
import { EditCustomer } from "./pages/EditCustomer";
import { ExportCustomerData } from "./pages/ExportCustomerData";

export const CustomerRoutes = [
  {
    path: "/customer",
    element: (
      <CustomerUIProvider>
        <CustomerUICard />
      </CustomerUIProvider>
    ),
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/customer/create",
    element: <CreateCustomer />,
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/customer/:id/detail",
    element: <CustomerDetail />,
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/customer/:id/edit",
    element: <EditCustomer />,
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/customer/:id/delete",
    element: <DeleteCustomer />,
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/customer/:id/confirm-done",
    element: <CustomerConfirmDoneDialog />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/customer/export",
    element: <ExportCustomerData />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
];
